import { IGetAllObraChecklistServicoUseCase } from "../../../presentation/useCases/read/get_all_obra_checklist_servico_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ObraChecklistServico } from "../../models/obra_checklist_servico";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllObraChecklistServicoUseCase
 */

export class GetAllObraChecklistServicoUseCase
  extends BasePaginatedUseCase<ObraChecklistServico>
  implements IGetAllObraChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObraChecklistServico(
    idObra: number | undefined,
    idObraAreaChecklist: number | undefined,
    statusChecklist: number | null,
    statusVerificacao: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObra === undefined) throw new Error('Id de obra invalido!');
    if (idObraAreaChecklist === undefined) throw new Error('Id de serviço invalido!');

    const response = await this.repository.getAllObraChecklistServico(
      idObra,
      idObraAreaChecklist,
      statusChecklist,
      statusVerificacao,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
